export default "__VITE_ASSET__BTQyJop8__"